// ============================
// src/components/ui/IconLink.jsx
// ============================
export default function IconLink({ href, label, children }) {
const isHttp = href.startsWith("http");
return (
<a href={href} target={isHttp ? "_blank" : undefined} rel={isHttp ? "noreferrer noopener" : undefined} className="inline-flex items-center gap-2 rounded-2xl border border-white/10 hover:border-emerald-300/60 px-4 py-2">
<span className="opacity-90">{children}</span>
<span className="font-medium">{label}</span>
</a>
);
}